module.exports = __webpack_public_path__ + "img/syukyaku-sytem-ira002.38e844ee.png";